/* eslint-disable @next/next/no-img-element */

import { getImageProps } from 'next/image';
import { Fragment } from 'react/jsx-runtime';

import { styles } from './UiModArtDirection.styles';

export interface ArtDirectionImage {
  media?: string;
  src: string;
}

export interface UiModArtDirectionProps {
  images: ArtDirectionImage[];
  alt: string;
  className?: string;
  imageClassName?: string;
  priority?: boolean;
}

export function UiModArtDirection({
  images,
  alt,
  className,
  imageClassName,
  priority
}: UiModArtDirectionProps) {
  const slots = styles();

  return (
    <picture className={slots.base({ className })}>
      {images.map((image, index) => {
        const { srcSet, ...rest } = getImageProps({
          src: image.src,
          fill: true,
          alt,
          priority
        }).props;

        const isLast = images.length === index + 1;

        return (
          <Fragment key={image.src + image.media}>
            <source
              key={image.src + image.media}
              media={image.media}
              srcSet={srcSet}
            />
            {isLast && (
              <img
                className={slots.image({ className: imageClassName })}
                {...rest}
                alt={alt}
              />
            )}
          </Fragment>
        );
      })}
    </picture>
  );
}
